// ============================================================
// 下载配置 —— 单一数据源
// 每次发版只需要修改本文件，全站所有下载链接/版本号都会同步更新。
// public/appVersion27.json 会在 build / dev 启动时由 vue.config.js 自动生成，
// 无需手动维护。
// ============================================================

const STATIC_HOST = 'https://static2.totok.ai/android';
const SITE_ORIGIN = 'https://totok.ai';

// 普通版 ToTok —— Android APK
const pubVersion = '1.9.19';
const pubBuild = '465';
const pubApkName = `totok-pub-release_v${pubVersion}(${pubBuild})_totok.apk`;

// Pro 版 ToTok —— Android APK
const proVersion = '2.9.3';
const proBuild = '10123';
const proApkName = `totok-pro-release_v${proVersion}(${proBuild})_pro.apk`;

// Pro 版下载页路径 slug（对应 Topaypilot.vue 的路由，也用在 tips 链接里）
const proPagePath = 'Pmxi7X0o';

module.exports = {
  // 普通版（ToTok）
  pub: {
    version: `${pubVersion}.${pubBuild}`,
    updateDate: 'Aug 14, 2026',
    releaseTime: '2026.08.14 15:00 (UTC +04:00)',
    platform: 'Android',
    size: '120 MB',
    sha256: '63b2c335f27b3513beab229087698b07aeb52c3952ea50d995573f9e7bedc98f',
    apkName: pubApkName,
    url: `${STATIC_HOST}/${pubApkName}`,
  },

  // Pro 版（ToTok Pro）—— Android
  pro: {
    version: `${proVersion}.${proBuild}`,
    updateDate: 'Aug 14, 2026',
    apkName: proApkName,
    url: `${STATIC_HOST}/${proApkName}`,
    pagePath: proPagePath,
    pageUrl: `${SITE_ORIGIN}/${proPagePath}`,
  },

  

  //下面的内容不用再维护
  // Pro 版（ToTok Pro）—— iPhone / TestFlight
  proIos: {
    version: `${proVersion}.${proBuild}`,
    updateDate: 'Jan 20, 2026',
    url: 'https://testflight.apple.com/join/JWdo8Anu',
  },

  // iOS App Store（普通版）
  ios: {
    url: 'https://apps.apple.com/app/apple-store/id1470928669?pt=120227142&ct=totok_website&mt=8',
  },
};
